export enum EquipmentRequestStatusEnum{
    Submitted = "Submitted", // Подана
    Pending = "Pending", // На рассмотрении
    Success = "Success", // Одобрена
    Supplied = "Supplied", // Оборудование поставлено
    Rejected = "Rejected" // Отклонена
}